module.exports = __webpack_public_path__ + "img/ttkj_en.e3e86012.png";